<template>
  <v-form @submit.prevent="handleLogin" ref="form" class="loginForm pa-12 ma-auto text-center">
    <div class="loginForm-header mb-12">
      <div class="loginForm-header-logo">
        <img src="@/assets/app-logo.png" alt="Mank Logo">
      </div>
      <div class="loginForm-header-title">
        <h2 class="text-h5 text-bold">
          Welcome to Mank!
        </h2>
        <h2 class="text-h7 text--secondary">
          Please login to continue to control panel.
        </h2>
      </div>
    </div>
    <div class="loginForm-body mb-12">
      <div class="loginForm-body-input mb-6">
        <div class="text-element-2 text-semibold text-left mb-4">
          Email
        </div>
        <MankTextField
          variant="solo"
          v-model="email"
          placeholder="Enter Your Email"
          :rules="emailRules"
          type="email"
          required/>
      </div>
      <div class="loginForm-body-input mb-4">
        <div class="text-element-2 text-semibold text-left mb-4">
          Password
        </div>
        <MankTextField
          variant="solo"
          v-model="password"
          placeholder="Enter Your Password"
          :rules="passwordRules"
          :type="showPassword ? 'text' : 'password'"
          :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
          @click:append="showPassword = !showPassword"
          required/>
      </div>
      <div class="loginForm-body-options d-flex align-center justify-space-between mt-2 mb-2">
        <v-checkbox
          v-model="rememberMe"
          label="Remember me"
          hide-details
          dense
          class="mt-0 loginForm-remember"/>
        <span
          class="text-primary text-semibold text-element-2 cursor-pointer"
          @click="$router.push('/forgot-password')">
          Forgot password?
        </span>
      </div>
    </div>

    <v-btn
      type="submit"
      color="primary"
      block
      :loading="loading"
      :disabled="!valid"
      elevation="0"
      class="mt-6">
      Login
    </v-btn>

    <div class="mt-6 text-element-2">
      Don't have an account?
      <span
        class="text-primary text-semibold cursor-pointer"
        @click="$router.push('/signup')">
        Sign up
      </span>
    </div>
  </v-form>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      rememberMe: false,
      loading: false,
      emailRules: [
        (v) => !!v || 'This field is required',
        (v) => /.+@.+\..+/.test(v) || 'Please enter a valid email address',
      ],
      passwordRules: [
        (v) => !!v || 'This field is required',
      ],
    };
  },
  computed: {
    valid() {
      const emailValid = this.email && this.emailRules.every((rule) => rule(this.email) === true);
      const passwordValid = this.password && this.passwordRules.every((rule) => rule(this.password) === true);
      return emailValid && passwordValid;
    },
  },
  methods: {
    async handleLogin() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.error = null;
        this.success = null;
        try {
          await this.$store.dispatch('auth/login', {
            email: this.email,
            password: this.password,
            rememberMe: this.rememberMe,
          });
          // Response interceptor loading'i kapattı; overlay yönlendirene kadar açık kalsın
          this.$store.commit('ui/SET_LOADING', true);
          setTimeout(() => {
            this.$store.commit('ui/SET_LOADING', false);
            this.$router.push({ path: '/dashboard', query: { loginSuccess: '1' } });
          }, 1500);
        } catch {
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.loginForm {
  border-radius: 16px;
  width: 360px;
  background: $light-surface-2;
}

.cursor-pointer {
  cursor: pointer;
}

.loginForm-body-options {
  min-height: 40px;
}

.loginForm-remember ::v-deep .v-input__control {
  min-height: auto;
}

/* Auth formu beyaz zemin üzerinde; mank-input'a çerçeve ver ki belli olsun */
.loginForm ::v-deep .mank-input .v-input__slot {
  border: 1px solid $light-surface-3;
  border-radius: 8px;
}
.loginForm ::v-deep .mank-input.v-input--is-focused .v-input__slot {
  border-color: $light-surface-4;
}

::v-deep .v-btn--loader {
  .v-btn__content {
    flex: none;
  }
  .v-btn__loader {
    position: relative;
    left: auto;
    margin-right: 8px;
  }
}
</style>
